import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP105_Request,
  IAPI_APP105_Response,
  IAPI_APP108_Request,
  IAPI_APP108_Response,
  IAPI_APP109_Request,
  IAPI_APP109_Response,
  IAPI_CON001_Request,
  IAPI_CON001_Response,
} from "../../../type/apiType";

// 契約者未処理申請届出等一覧参照
const httpAPI_APP105 = async (
  param: IAPI_APP105_Request
): Promise<IAPI_APP105_Response> => {
  let res = await http.post(ApiUrl.API_APP105, {
    ...param,
  });
  return res.data;
};

// 督促日手動更新
const httpAPI_APP108 = async (
  param: IAPI_APP108_Request
): Promise<IAPI_APP108_Response> => {
  let res = await http.post(ApiUrl.API_APP108, {
    ...param,
  });
  return res.data;
};

// 退職手当金請求放棄更新
const httpAPI_APP109 = async (
  param: IAPI_APP109_Request
): Promise<IAPI_APP109_Response> => {
  let res = await http.post(ApiUrl.API_APP109, {
    ...param,
  });
  return res.data;
};

/**
 * 契約者一覧参照API
 * @return httpAPI_CON001
 */
const httpAPI_CON001 = async (
  param: IAPI_CON001_Request
): Promise<IAPI_CON001_Response> => {
  let res = await http.post(ApiUrl.API_CON001, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP105, httpAPI_APP108, httpAPI_APP109, httpAPI_CON001 };
